import { render, staticRenderFns } from "./adminLink.vue?vue&type=template&id=c1ad516e"
import script from "./adminLink.vue?vue&type=script&lang=js"
export * from "./adminLink.vue?vue&type=script&lang=js"
import style0 from "./adminLink.vue?vue&type=style&index=0&id=c1ad516e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports